import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const DragAndDropGlobalStyleSettingsContainer = lazy(() =>
  import("@scenes/EmailSettings/DragAndDropGlobalStyleSettings/DragAndDropGlobalStyleSettingsContainer").then(
    (module) => ({
      default: module.DragAndDropGlobalStyleSettingsContainer,
    })
  )
);

export const dragAndDropEmailEditorSettingsNRO: NavigationRoutingObject = {
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("drag-and-drop-email-editor-settings-nro-heading", "Drag-And-Drop Email Editor Settings"),
  pageNameForTracking: () => "Drag-And-Drop Email Editor Settings",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  Component: DragAndDropGlobalStyleSettingsContainer,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
};
